import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Terminal20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M6.93934 10.5L4.96967 8.53033L6.03033 7.46967L9.06066 10.5L6.03033 13.5303L4.96967 12.4697L6.93934 10.5Z'
      fill='currentColor'
    />
    <path d='M10 13.75H14V12.25H10V13.75Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.25 2.57143C1.25 1.84162 1.84162 1.25 2.57143 1.25H17.4286C18.1584 1.25 18.75 1.84162 18.75 2.57143V17.4286C18.75 18.1584 18.1584 18.75 17.4286 18.75H2.57143C1.84162 18.75 1.25 18.1584 1.25 17.4286V2.57143ZM2.75 2.75V4.25H4.25V2.75H2.75ZM5.75 2.75V4.25H17.25V2.75H5.75ZM2.75 17.25V5.75H17.25V17.25H2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Terminal20.displayName = 'Terminal20';
export default Terminal20;
